import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import { TEXT_SECONDARY_COLOR } from "../../theme";

const AlertaMensagem = props => {
  const { mensagem, fecharMensagem, handleClick, iconeMensagem } = props;
  const classes = useStyles(props);
  const larguraMensagem = fecharMensagem ? 11 : 12;
  const larguraMensagemMobile = fecharMensagem ? 10 : 12;
  return (
    <Grid
      className={`${handleClick && classes.cursor} ${classes.root}`}
      container
      spacing={2}
      onClick={handleClick}
      direction="row"
      justify="space-between"
    >
      <Grid
        item
        xs={larguraMensagemMobile}
        sm={larguraMensagem}
        md={larguraMensagem}
        lg={larguraMensagem}
      >
        <Grid
          container
          direction="row"
          justify="space-between"
          alignContent="center"
        >
          {iconeMensagem && (
            <Grid item xs={2} className={classes.iconeMensagem}>
              {iconeMensagem}
            </Grid>
          )}
          <Grid
            id="contenedor-mensagem"
            className={classes.containerTexto}
            item
            xs={iconeMensagem ? 10 : 12}
          >
            <Typography className={classes.texto}>{mensagem}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  root: {
    marginTop: "9px",
    marginLeft: "1px",
    border: "1px solid #D4D4E9",
    borderRadius: "2px",
    backgroundColor: "rgba(192, 192, 222, 0.35)",
    color: TEXT_SECONDARY_COLOR,
    maxWidth: "calc(100% - 2px)",
  },
  iconeMensagem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: TEXT_SECONDARY_COLOR,
  },
  containerTexto: {
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
  },
  texto: {
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
  },
  cursor: {
    cursor: "pointer",
  },
});
export default AlertaMensagem;